import {formatNumber} from './format'

/**
 * Gets the rounding function for the type of trade.
 * See original code at https://git.io/vxJDj
 *
 * @param {string} type the type  of trade (bid, ask)
 */
export const getRoundFunc = (type: string = 'bids') =>
  (() => {
    switch (type) {
    case 'bids':
      return 'floor'
    case 'asks':
      return 'ceil'
    default:
      if (Math[type]) return Math[type]
      throw new Error('getRoundFunc called with unknown type')
    }
  })()

/**
 * Round a decimal number to the specified precision.
 *
 * @param {number | string} input
 * @param {number} precision
 * @param {function} func the rounding function
 * @param {bool} format should format?
 */
export const decRound = (
  input: number | string,
  precision: number,
  func: string = 'round',
  format?: boolean = false
) => {
  const factor = 10 ** precision
  // better browser support epsilon
  // see unit tests.
  const adj = 3
  let num = (+input + 1 / 10 ** (precision + adj)) * factor
  if (typeof func === 'string') {
    const dps = adj - 1
    num = parseInt(num * 10 ** dps, 10) / 10 ** dps
    func = getRoundFunc(func)
  }
  if (typeof func !== 'function') throw new Error('decRound unknown rounding func')
  if (format) {
    return formatNumber(func(num) / factor, precision)
  }
  return (func(num) / factor).toFixed(precision)
}

export const floor = (num: number | string, digit: number = 2, format) =>
  decRound(num, digit, 'floor', format)

export const ceil = (num: number | string, digit: number = 2) =>
  decRound(num, digit, 'ceil')
